import { PatientPreviewCurrentMedications } from "~/providers/components";
import { MedicationsData } from "~/providers/utils/types/patientPreviewTypes";
import { PreviewSectionLayout } from "../../common/PreviewSectionLayout";
import { Allergies } from "../Allergies";

interface PatientPreviewCurrentMedicationsV2Props {
  medications?: MedicationsData[];
  allergies?: string;
}

export const PatientPreviewCurrentMedicationsV2 = ({
  medications,
  allergies,
}: PatientPreviewCurrentMedicationsV2Props) => (
  <PreviewSectionLayout title="Current medications">
    {!medications ? (
      <p>No current medications</p>
    ) : (
      <PatientPreviewCurrentMedications medications={medications} />
    )}

    <Allergies allergies={allergies} />
  </PreviewSectionLayout>
);
